import { render, staticRenderFns } from "./AutomatedTasksDeleteDoc.vue?vue&type=template&id=26849a1c"
import script from "./AutomatedTasksDeleteDoc.vue?vue&type=script&lang=js"
export * from "./AutomatedTasksDeleteDoc.vue?vue&type=script&lang=js"
import style0 from "./AutomatedTasksDeleteDoc.vue?vue&type=style&index=0&id=26849a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports